import { desktop } from '@hg/stylizator/utils'
import * as React from 'react'
import { IWPGBlock } from 'react-gutenberg'
import styled from 'styled-components'

import PromoBanner from './PromoBanner'

export interface IPromoBannerAttributes {
  title: string
  description: React.ReactNode
  buttonText: string
  url: string
  mediaId: number
  mediaUrl: string
}

const PromoBannerBlock: React.FC<IWPGBlock> = (props) => {
  const attributes = props.attrs as IPromoBannerAttributes

  return (
    <Spacing>
      <PromoBanner
        title={attributes.title}
        description={attributes.description}
        buttonText={attributes.buttonText}
        buttonUrl={attributes.url}
        image={attributes.mediaUrl}
      />
    </Spacing>
  )
}

const Spacing = styled.div`
  margin: 40px -16px;

  @media ${desktop} {
    margin: 56px 0;
  }
`

export default PromoBannerBlock
